import ManualTradeConfirmation from './ManualTradeConfirmation';

export default ManualTradeConfirmation;
